/**
 * @generated SignedSource<<8a73b4387e40862aac85495ea5d125a5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ExternalPaymentProvider = "EDUZZ" | "GREENN" | "GURU" | "HEROSPARK" | "HOTMART" | "HUBLA" | "KIRVANO" | "KIWIFY" | "SCARF_PAY" | "STRIPE" | "TICTO" | "TMB" | "%future added value";
export type integracoesCheckoutNovoExistingQuery$variables = {
  club: string;
};
export type integracoesCheckoutNovoExistingQuery$data = {
  readonly club: {
    readonly integrations: ReadonlyArray<{
      readonly __typename: string;
      readonly id: string;
      readonly provider?: ExternalPaymentProvider;
    }>;
  };
};
export type integracoesCheckoutNovoExistingQuery = {
  response: integracoesCheckoutNovoExistingQuery$data;
  variables: integracoesCheckoutNovoExistingQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "club"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "club"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "integrations",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    (v2/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "provider",
          "storageKey": null
        }
      ],
      "type": "PaymentIntegration",
      "abstractKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "integracoesCheckoutNovoExistingQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "integracoesCheckoutNovoExistingQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fb7ec0ea78f06e9f33927a83d217bbf8",
    "id": null,
    "metadata": {},
    "name": "integracoesCheckoutNovoExistingQuery",
    "operationKind": "query",
    "text": "query integracoesCheckoutNovoExistingQuery(\n  $club: String!\n) {\n  club(slug: $club) {\n    integrations {\n      __typename\n      id\n      ... on PaymentIntegration {\n        provider\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "e94c6c14c47df5918e465d0dba7bae3b";

export default node;
